import React from 'react';
import Assets from '../components/Assets';
import AssetsGallery from '../components/AssetsGallery';

function AssetsPage() {
  return (
    <div className="page">
      <Assets />
      <AssetsGallery />
    </div>
  );
}

export default AssetsPage;
